import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import ListGroup from "react-bootstrap/ListGroup";
import { ButtonContainer } from "../../ui/BaseComponents";
import ApproveProvider from "../approve/ApproveProvider";
import RejectProvider from "../reject/RejectProvider";
import axios from "axios";
import { VehicleData } from "../../../interfaces/vehicle";
import SendBackgroundCheck from "../sendBackgroundCheck/SendBackgroundCheck";
import { BACKGROUND_CHECK_STATUS } from "../../constants/ BACKGROUND_CHECK_STATUS";
import SetBackgroundCheckReview from "../setBackgroundCheckReview/SetBackgroundCheckReview";

export default function PendingProvidersDetails({
  data,
  id: userId,
  updateListData,
}) {
  const [isLoadingVehicle, setIsLoadingVehicle] = useState(true);
  const [vehicleData, setVehicleData] = useState<VehicleData>({
    make: "",
    model: "",
    color: "",
    plate_number: "",
    year: "",
    name: "",
    user_id: "",
    id: "",
  });
  const fetchVehicleData = async () => {
    try {
      setIsLoadingVehicle(true);
      const { data } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userVehicle/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data) {
        setVehicleData({ ...data });
      } else {
        setVehicleData({
          make: "",
          model: "",
          color: "",
          plate_number: "",
          year: "",
          name: "",
          user_id: "",
          id: "",
        });
      }

      setIsLoadingVehicle(false);
    } catch (e) {
      setIsLoadingVehicle(false);
      throw e;
    }
  };

  useEffect(() => {
    fetchVehicleData();
  }, [data.provider_id]);

  return (
    <>
      <Accordion flush defaultActiveKey={"0"}>
        <Accordion.Item eventKey={"0"}>
          <Accordion.Header>Basic Information</Accordion.Header>
          <Accordion.Body>
            <ListGroup variant='flush'>
              <ListGroup.Item>First Name: {data.first_name}</ListGroup.Item>
              <ListGroup.Item>Last Name: {data.last_name}</ListGroup.Item>
              <ListGroup.Item>Email Address: {data.email}</ListGroup.Item>
              <ListGroup.Item>Phone Number: {data.phone_number}</ListGroup.Item>
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>
        {/* <Accordion.Item eventKey={"1"}>
          <Accordion.Header>Company Information</Accordion.Header>
          <Accordion.Body>
            <ListGroup variant='flush'>
              <ListGroup.Item>Company Name: {data.company_name}</ListGroup.Item>
              <ListGroup.Item>
                Address Line 1: {data.company_address_line_1}
              </ListGroup.Item>
              <ListGroup.Item>
                Address Line 2: {data.company_address_line_2}
              </ListGroup.Item>
              <ListGroup.Item>State: {data.company_state}</ListGroup.Item>
              <ListGroup.Item>Postal Code: {data.zip_postal}</ListGroup.Item>
              <ListGroup.Item>
                Company Phone No.: {data.phone_number}
              </ListGroup.Item>
            </ListGroup>
          </Accordion.Body> */}
        {/* </Accordion.Item> */}
        <Accordion.Item eventKey={"2"}>
          <Accordion.Header>Vehicle Information</Accordion.Header>

          {isLoadingVehicle ? (
            <Accordion.Body>
              <div
                className='d-flex justify-content-center align-items-center'
                id='basicLoader'
                style={{}}
              >
                <h6 className='text-center'>Loading</h6>
                <div className='ml-3'>
                  <div className='ml-3 spinner-grow text-danger'></div>
                  <div className='ml-3 spinner-grow text-warning'></div>
                  <div className='ml-3 spinner-grow text-success'></div>
                </div>
              </div>
            </Accordion.Body>
          ) : (
            <>
              <Accordion.Body>
                <ListGroup variant='flush'>
                  <ListGroup.Item>Name: {vehicleData.name}</ListGroup.Item>
                  <ListGroup.Item>Year: {vehicleData.year}</ListGroup.Item>
                  <ListGroup.Item>Make: {vehicleData.make}</ListGroup.Item>
                  <ListGroup.Item>Model: {vehicleData.model}</ListGroup.Item>
                  <ListGroup.Item>Color: {vehicleData.color}</ListGroup.Item>
                  <ListGroup.Item>
                    License Plate No.: {vehicleData.plate_number}
                  </ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </>
          )}
        </Accordion.Item>
        <Accordion.Item eventKey={"3"}>
          <ButtonContainer
            style={{ justifyContent: "space-evenly", marginTop: "1em" }}
          >
            {BACKGROUND_CHECK_STATUS.PENDING_ADMIN_INPUT ===
              data.background_check_status && (
              <SendBackgroundCheck handleSuccess={updateListData} data={data} />
            )}
            {BACKGROUND_CHECK_STATUS.PENDING_PROVIDER_INPUT ===
              data.background_check_status && (
              <SetBackgroundCheckReview
                handleSuccess={updateListData}
                data={data}
              />
            )}
            {BACKGROUND_CHECK_STATUS.IN_REVIEW ===
              data.background_check_status && (
              <>
                <ApproveProvider handleSuccess={updateListData} id={data.id} />
                <RejectProvider handleSuccess={updateListData} id={data.id} />
              </>
            )}

            {/* <RejectProvider id={data.id} /> */}
          </ButtonContainer>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
